/**
 * Coverage Legend Content
 * Displays the signal coverage legend
 */

import React from 'react';
import { cn } from '@ais-ui/utils';
import { useCoverage } from '../../Coverage/CoverageContext';
import { ItemInterval, useGridColumns } from '../shared';

export const CoverageLegendContent: React.FC = () => {
  const { coverageLegend } = useCoverage();

  const gridColumnsClass = useGridColumns({
    itemCount: coverageLegend.items.length,
    maxItemsPerColumn: 10,
    maxColumns: 2,
  });

  return (
    <div className={cn('grid gap-y-1.5 gap-x-4', gridColumnsClass)}>
      {coverageLegend.items.map((item, index) => (
        <ItemInterval
          key={index}
          legend={coverageLegend}
          item={item}
          showBorder={false}
        />
      ))}
    </div>
  );
};
